<div class="row animate__animated animate__fadeIn">

  @if (!fromOnboarding) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
      @if(step == 1){
        <h1 class="titulo-simpli titulo-simpli-responsive">Completa el proceso de simulación</h1>
        <small class="subtitulo-simpli titulo-simpli-responsive">Selecciona el vencimiento de tus facturas</small>
        }@else{
        <h1 class="titulo-simpli titulo-simpli-responsive">Detalle de tu simulación</h1>
        <small class="subtitulo-simpli titulo-simpli-responsive">Revisa el detalle de tu simulación</small>
      }
    </div>
  }


  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">

    <div class="row">

      <div [ngClass]="fromOnboarding ? 'col-lg-0 col-md-0 col-sm-0 col-xs-0' : 'col-lg-3 col-md-2 col-sm-1 col-xs-12'">
      </div>

      <div
        [ngClass]="fromOnboarding ? 'col-lg-12 col-md-12 col-sm-12 col-xs-12' : 'col-lg-6 col-md-8 col-sm-10 col-xs-12'">
        <mat-card [id]="fromOnboarding ? '' : 'card-simulation'"
          [ngClass]="fromOnboarding ? 'no-border-card' : 'card-tabla'">


          <!--STEPPER CONTROL-->
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-responsive"
            [style.margin-top]="fromOnboarding ? '0px' : '40px'"
            [style.display]="fromOnboarding ? 'none' : 'block'">

            <div class="container-stepper-simpli">

              <div id="step-simpli1" class="stepper-simpli stepper-simpli-active">
                <span class="material-symbols-outlined">edit</span>
                <div class="step-text">Vencimiento</div>

                <div class="line-step-simpli"></div>
              </div>



              <div id="step-simpli2" class="stepper-simpli">
                <span class="material-symbols-outlined">note</span>
                <div class="step-text">Resumen</div>

              </div>



            </div>

          </div>


          @if (step == 1 && set_vencimiento == 0 ) {
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
              <div style="text-align: center;">
                <mat-label class="l-i">Monto a simular:</mat-label>
                <mat-label class="l-d" style="position: relative;">$ {{formatMoney(monto_total)}} <span
                  style="margin-left: 10px; position: absolute;margin-top: -3px;"
                  matTooltip="El monto a simular es el resultado de la suma de los montos de cada factura agregada a la simulación."
                  matSuffix class="material-icons-outlined">
                  info
                </span></mat-label>
              </div>
            </div>
          }


          @if(acapo == true){

            <loading-interno></loading-interno>

            }@else{

            @if (step == 1 && set_vencimiento == 0) {
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
                <form [formGroup]="valFormFilter" style="margin-top: 30px;">
                  <mat-form-field appearance="fill" style="position: relative;width: 90%;">
                    <mat-label>Porcentaje de financiamiento</mat-label>
                    <input matInput min="20" max="100" type="number" formControlName="anticipo" (change)="alert_anticipo()"
                      (keyup)="validate_anticipo($event)" (blur)="validate_anticipo($event)">
                    <mat-hint>Asigna el porcentaje de financiamiento</mat-hint>
                    @if (valFormFilter.controls['anticipo'].hasError('required')) {
                      <mat-error>
                        Este campo es <strong>obligatorio</strong>
                      </mat-error>
                    }
                    @if (valFormFilter.controls['anticipo'].hasError('min')) {
                      <mat-error>
                        El porcentaje mínimo permitido es <strong>20%</strong>.
                      </mat-error>
                    }
                    @if (valFormFilter.controls['anticipo'].hasError('max')) {
                      <mat-error>
                        El porcentaje máximo permitido es <strong>100%</strong>.
                      </mat-error>
                    }
                    <mat-icon matSuffix class="material-icons">
                      percent
                    </mat-icon>
                    <span style="position: absolute;margin-left: 10px;top:11px"
                      matTooltip="El 95% es establecido considerando las condiciones de solicitud de línea. El aumento de este porcentaje, estará sujeto a evaluación."
                      matSuffix class="material-icons-outlined info-icon">
                      info
                    </span>
                  </mat-form-field>
                  <mat-form-field appearance="fill" style="width: 90%;">
                    <mat-label>Tipo de vencimiento</mat-label>
                    <mat-select formControlName="tipo_vencimiento" (selectionChange)="statuschange($event)">
                      <!--fecha de vencimiento, muchas facturas-->
                      @if (!single_factura) {
                        <mat-option value="1">Asignar misma fecha de vencimiento</mat-option>
                      }
                      @if (!single_factura) {
                        <mat-option value="3">Asignar misma cantidad de días</mat-option>
                      }
                      @if (!single_factura) {
                        <mat-option value="2">Asignar distintas fechas de vencimiento</mat-option>
                      }
                      @if (!single_factura) {
                        <mat-option value="4">Asignar cantidad de días por factura</mat-option>
                      }
                      <!--opciones de 1 sola factura-->
                      @if (single_factura) {
                        <mat-option value="6">Asignar fecha de vencimiento</mat-option>
                      }
                      @if (single_factura) {
                        <mat-option value="5">Asignar días de vencimiento</mat-option>
                      }
                    </mat-select>
                    <mat-hint>Selecciona el tipo de vencimiento para tus facturas</mat-hint>
                    @if (valFormFilter.controls['tipo_vencimiento'].hasError('required')) {
                      <mat-error>
                        Este campo es <strong>obligatorio</strong>
                      </mat-error>
                    }
                  </mat-form-field>
                  <!--6-->
                  @if ((selected == 6 || selected == 1) && single_factura == true || (selected == 6 || selected == 1) && single_factura == false) {
                    <mat-form-field appearance="fill" (click)="picker.open()"
                      style="width: 90%;">
                      <mat-label>Fecha de vencimiento</mat-label>
                      <input type="text" [min]="getMinDateFromEmision()" [max]="getMaxDateFromEmision()" matInput
                        [matDatepicker]="picker" (dateChange)="fecha_todas($event)" formControlName="fecha_vencimiento_utc"
                        readonly>
                      <mat-hint>Asigna la fecha de vencimiento para tus facturas </mat-hint>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                      @if (valFormFilter.controls['fecha_vencimiento_utc'].hasError('invalid')) {
                        <mat-error>
                          Este campo es <strong>obligatorio</strong>
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  <!--5-->
                  @if ((selected == 5 || selected == 3) && single_factura == true || (selected == 5 || selected == 3) && single_factura == false) {
                    <mat-form-field appearance="fill"
                      style="width: 90%;">
                      <mat-label>Cantidad de días</mat-label>
                      <input matInput type="number" min="30" max="360" formControlName="dias_vencimiento" (keyup)="validate_days($event)" (change)="capturar_fecha_por_dias($event)">
                      <mat-hint>Asigna la cantidad de días de vencimiento (entre 30 y 360)</mat-hint>
                      @if (valFormFilter.controls['dias_vencimiento'].hasError('required')) {
                        <mat-error>
                          Este campo es <strong>obligatorio</strong>
                        </mat-error>
                      }
                      @if (valFormFilter.controls['dias_vencimiento'].hasError('min')) {
                        <mat-error>
                          El mínimo permitido es <strong>30</strong>.
                        </mat-error>
                      }
                      @if (valFormFilter.controls['dias_vencimiento'].hasError('max')) {
                        <mat-error>
                          El máximo permitido es <strong>360</strong>.
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="btn-simpli-container">
                        <button class="primary-button" type="button" [disabled]="acapo" mat-flat-button
                          (click)="submitForm($event, valFormFilter.value)">
                          @if (acapo == false) {
                            <span>Continuar</span>
                          }
                          @if (acapo == true) {
                            <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
                          }
                        </button>
                        <button class="secondary-button" type="button" mat-flat-button (click)="simular()">
                          Volver
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            }

            @if (set_vencimiento == 1 || set_vencimiento == 2) {
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
                <div style="text-align: center;">
                  @if (set_vencimiento == 1) {
                    <h1 class="title-step2">Asigna una fecha para cada factura</h1>
                  }
                  @if (set_vencimiento == 2) {
                    <h1 class="title-step2">Asigna una cantidad de días para cada factura</h1>
                  }
                  <mat-label class="l-i">Monto a simular:</mat-label>
                  <mat-label class="l-d" style="position: relative;">$ {{formatMoney(monto_total)}} <span
                    style="margin-left: 10px; position: absolute;margin-top: -3px;"
                    matTooltip="El monto a simular es el resultado de la suma de los montos de cada factura agregada a la simulación."
                    matSuffix class="material-icons-outlined">
                    info
                  </span></mat-label>
                </div>
              </div>
            }

            @if (set_vencimiento == 1) {
              <div
                class="col-lg-11 col-md-11 col-sm-11 col-xs-12 col-top animate__animated animate__fadeIn"
                style="margin: 0 auto;">
                <div class="scroll-container add_factoring">
                  @for (i of facturas; track i; let index = $index) {
                    <div class="container-facturas">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <div style="display: flex; align-items: center; margin: 10px 0;">
                            <span style="margin-right: 10px; min-width: 80px;">N° Factura:</span>
                            <span>{{i.folio}}</span>
                          </div>
                          <div style="display: flex; align-items: center; margin: 10px 0;">
                            <span style="margin-right: 10px; min-width: 80px;">Deudor:</span>
                            <span>{{i.deudor}}</span>
                          </div>
                          <div style="display: flex; align-items: center; margin: 10px 0;">
                            <span style="margin-right: 10px; min-width: 80px;">Monto:</span>
                            <span>${{formatMoney(i.monto)}}</span>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="text-align: center;margin-top: 5px;">
                          <div class="container-vencimiento l-vencimiento" style="text-align: justify;">Asigna la fecha de
                          vencimiento</div>
                          <div [ngClass]="{'container-vencimiento':true}">
                            <mat-form-field appearance="fill" style="width: 100%;">
                              <mat-label>Fecha de vencimiento</mat-label>
                              <input type="text" readonly matInput [matDatepicker]="picker"
                                [min]="getMinDateForFactura(index)" [max]="getMaxDateForFactura(index)"
                                (dateChange)="fecha_individual($event, index)" #pickerInput{{index}}>
                              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="btn-simpli-container">
                      <button [disabled]="acapo" class="primary-button" mat-flat-button (click)="validate_date()">
                        @if (acapo == false) {
                          <span>Continuar</span>
                        }
                        @if (acapo == true) {
                          <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
                        }
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }

            @if (set_vencimiento == 2) {
              <div
                class="col-lg-11 col-md-11 col-sm-11 col-xs-12 col-top animate__animated animate__fadeIn"
                style="margin: 0 auto;">
                <div class="scroll-container add_factoring">
                  @for (i of facturas; track i; let index = $index) {
                    <div class="container-facturas">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <div style="display: flex; align-items: center; margin: 10px 0;">
                            <span style="margin-right: 10px; min-width: 80px;">N° Factura:</span>
                            <span>{{i.folio}}</span>
                          </div>
                          <div style="display: flex; align-items: center; margin: 10px 0;">
                            <span style="margin-right: 10px; min-width: 80px;">Deudor:</span>
                            <span>{{i.deudor}}</span>
                          </div>
                          <div style="display: flex; align-items: center; margin: 10px 0;">
                            <span style="margin-right: 10px; min-width: 80px;">Monto:</span>
                            <span>${{formatMoney(i.monto)}}</span>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="text-align: center; margin-top: 5px;">
                          <div style="margin-bottom: 15px;">
                            <label>Asigna la cantidad de días de vencimiento</label>
                          </div>
                          <mat-form-field appearance="fill" style="width: 90%;">
                            <mat-label>Cantidad de días</mat-label>
                            <input matInput min="30" max="360" type="number" (blur)="validate_individual_days($event, index)"
                              (change)="dias_individual($event, index)">
                            <mat-hint>Entre 30 y 360 días</mat-hint>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="btn-simpli-container">
                      <button [disabled]="acapo" class="primary-button" mat-flat-button (click)="validate_date()">
                        @if (acapo == false) {
                          <span>Continuar</span>
                        }
                        @if (acapo == true) {
                          <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
                        }
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          }




          <!--STEP RESUMEN-->
          @if (step == 2 && set_vencimiento == 0) {
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="box-info-onboarding">
                    <div class="icon"><span class="material-symbols-outlined">info</span></div>
                    <div>La apertura de la línea de factoring tiene un costo aproximado de $98.500, que se descontará de
                      la
                      primera operación.
                    </div>
                  </div>
                  @if (cantidad_facturas <= 7) {
                    <div class="caja-rosa animate__animated animate__fadeIn">
                      <h1 class="titulo-interno">Facturas de la simulación</h1>
                      <div class="contenedor-facturas add_factoring">
                        <div class="row" style="margin-bottom: 5px;">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Cantidad de facturas:</div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="font-weight: bold;text-align: right;">
                            @if(loading_cantidad){
                              <skeleton-loader></skeleton-loader>
                              }@else{
                              {{cantidad_facturas}}
                            }
                          </div>
                        </div>
                        <div>
                          <div style="text-align: right;">
                            <mat-label class="pink-label" (click)="detalle_factura2()">Abrir detalle <span class="material-symbols-outlined">chevron_right</span></mat-label>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (cantidad_facturas == 0) {
                    <div class="caja-rosa animate__animated animate__fadeIn" style="padding-left: 0px;"
                      >
                      <div style="text-align: center;margin-top: 20px;margin-bottom: 20px;">
                        <span class="material-symbols-outlined mat-spin" style="color: gray; font-size: 25px;">progress_activity</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="box-info-facturas">
                    <div class="titulo-interno">Montos asociados</div>
                    <div>
                      <div class="row row-montos">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto total simulado:</div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                          @if(loading){
                            <skeleton-loader></skeleton-loader>
                            }@else{
                            ${{formatMoney(simulation.total)}}
                          }
                        </div>
                      </div>
                      <div class="row row-montos">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Porcentaje de financiamiento:</div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                          @if(loading){
                            <skeleton-loader></skeleton-loader>
                            }@else{
                            {{simulation.anticipo}}%
                          }
                        </div>
                      </div>
                      <div class="row row-montos">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto de anticipo:</div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                          @if(loading){
                            <skeleton-loader></skeleton-loader>
                            }@else{
                            ${{formatMoney(simulation.valor_anticipo_total)}}
                          }
                        </div>
                      </div>
                      <div class="row row-montos">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Vencimiento:</div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                          @if(loading){
                            <skeleton-loader></skeleton-loader>
                            }@else{
                            {{simulation.dias_promedio}} días
                          }
                        </div>
                      </div>
                      @if(expandir) {
                        <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Tasa de interés:</div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                            @if(loading){
                              <skeleton-loader></skeleton-loader>
                              }@else{
                              {{simulation.tasa_interes}}%
                            }
                          </div>
                        </div>
                        <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto total de interés:</div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                            @if(loading){
                              <skeleton-loader></skeleton-loader>
                              }@else{
                              ${{formatMoney(simulation.interes_total)}}
                            }
                          </div>
                        </div>
                        <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Comisión:</div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                            @if(loading){
                              <skeleton-loader></skeleton-loader>
                              }@else{
                              ${{formatMoney(simulation.comision)}}
                            }
                          </div>
                        </div>
                        <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Gastos operacionales:</div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                            @if(loading){
                              <skeleton-loader></skeleton-loader>
                              }@else{
                              ${{formatMoney(simulation.gastos)}}
                            }
                          </div>
                        </div>
                        <div class="row row-montos animate__animated  animate__faster animate__fadeIn" style="display: none;">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Diferencia de precios:</div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                            @if(loading){
                              <skeleton-loader></skeleton-loader>
                              }@else{
                              ${{settings.formatMoney(simulation.interes_total)}}
                            }
                          </div>
                        </div>
                        <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">IVA:</div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                            @if(loading){
                              <skeleton-loader></skeleton-loader>
                              }@else{
                              ${{settings.formatMoney(simulation.iva_operacion)}}
                            }
                          </div>
                        </div>
                        <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Excedentes:</div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                            @if(loading){
                              <skeleton-loader></skeleton-loader>
                              }@else{
                              ${{settings.formatMoney(simulation.excedentes)}}
                            }
                          </div>
                        </div>
                        <div class="row row-montos animate__animated  animate__faster animate__fadeIn" style="display: none;">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Costo de apertura:</div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                            @if(loading){
                              <skeleton-loader></skeleton-loader>
                              }@else{
                              ${{settings.formatMoney(98500)}}
                            }
                          </div>
                        </div>
                      }
                      <div (click)="expandir = !expandir"
                        style="display: flex;justify-content: center;align-items: center;gap: 10px;color: gray;font-size: 13px;cursor: pointer;">
                        @if(expandir){
                          contraer
                          }@else{
                          expandir
                        }
                        @if (expandir == false) {
                          <span>
                            <span class="material-symbols-outlined" style="font-size: 16px;">expand_more</span>
                          </span>
                        }
                        @if (expandir == true) {
                          <span>
                            <span class="material-symbols-outlined" style="font-size: 16px;">expand_less</span>
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="caja-rosa" style="padding-top: 15px; padding-bottom: 15px;">
                    <div class="forfacturas" style="margin-bottom: 0px;">
                      <div class="rowfacturas2">
                        <div class="titulo-interno" style="margin-bottom: 0px !important;">Monto líquido:</div>
                      </div>
                      <div class="rowfacturas">
                        <div class="strong-facturas2" style="margin-left: 50px;">
                        ${{formatMoney(simulation.monto_recibir)}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="contact-container" style="margin-top: 10px;">
                <div class="icons">
                  @if (fromOnboarding == true) {
                    <span (click)="editarSimulacion()"><span class="material-symbols-outlined">edit</span>Editar simulación</span>
                  }
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  @if(loading_pdf_ == false){
                    <span (click)="download_pdf()"><span class="material-symbols-outlined">download</span>Descargar simulación</span>
                    }@else{
                    <span style="opacity: 0.5;"><span class="material-symbols-outlined mat-spin">progress_activity</span> Descagar simulación</span>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="btn-simpli-container">
                    <button [disabled]="wait_to_send" class="primary-button" mat-flat-button
                      (click)="fromOnboarding ? continuar_onboarding() : alert_success()">
                      @if (wait_to_send==false) {
                        <mat-label> Continuar</mat-label>
                      }
                      @if (wait_to_send==true) {
                        <span><span class="material-symbols-outlined mat-spin" style="color: var(--simpli-secondary);">progress_activity</span></span>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }



        </mat-card>
      </div>

      <div [ngClass]="fromOnboarding ? 'col-lg-0 col-md-0 col-sm-0 col-xs-0' : 'col-lg-3 col-md-2 col-sm-1 col-xs-12'">
      </div>

    </div>

  </div>

</div>